import axios from 'axios'
import get from 'lodash/get'
import { error } from './message'
import config from '@/config'
import { t } from '@/shared/i18n'

axios.interceptors.response.use((response) => response, (err) => Promise.reject(err.response))

const request = (method, url, payload) => axios({
  method,
  url: `/${url}`,
  data: payload,
  headers: { __RequestVerificationToken: config.REQUEST_VERIFICATION_TOKEN }
}).catch((err) => {
  const errorMsg = get(err, 'data.message', '') ? get(err, 'data.message', '') : t('Common.GenericMessageError')

  error(errorMsg)
  return err
})

// eslint-disable-next-line import/prefer-default-export
export { request }
